import {
  getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationFetcher,
  getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersId200 } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

/**
 * 社内報更新APIを実行するカスタムフック。
 *
 * @param threeLetterCode - パートナーコード
 * @param id - 社内報ID
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePatchClientNewsletter = (
  threeLetterCode: string,
  id: number,
  options?: {
    onSuccess?: (data: PatchApiV1ThreeLetterCodeClientAdminsClientNewslettersId200) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationKey(threeLetterCode, id),
    getPatchApiV1ThreeLetterCodeClientAdminsClientNewslettersIdMutationFetcher(threeLetterCode, id),
    options
  );
};
